<template>
    <div class="tags-view" @click="beginInput">
        <a-tag :key="`tags${tag.id}`" v-for="tag,index in dynamicTags" closable 
            @close="handleClose(index)">
            {{ tag.name }}
        </a-tag>
        <a-input v-if="inputVisible" class="input-new-tag" style="width: 100%;" v-model="inputValue" ref="saveTagInput"
            size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
        </a-input>
    </div>
</template>

<script>
export default {
    name: 'inputTag',
    props: {
        tags: {
            type: Array,
        },
    },
    watch: {
        tags: {
            deep: true,
            immediate: true,
            handler(val) {
                this.dynamicTags = val || []
            }
        }
    },
    data() {
        return {
            dynamicTags: [],
            inputVisible: false,
            inputValue: ''
        };
    },
    methods: {
        handleClose(index) {
            this.dynamicTags.splice(index, 1);
            console.log("del",this.dynamicTags)
            this.$emit('changed', this.dynamicTags)
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        beginInput() {
            this.showInput();
        },
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push({id: new Date().getTime(), name: inputValue});
            }
            const inputElement = this.$refs.saveTagInput.$refs.input; // 获取input DOM元素
            const isFocused = document.activeElement === inputElement; // 判断是否为当前焦点
            this.inputVisible = isFocused;
            
            this.inputValue = '';
            this.$emit('changed', this.dynamicTags)
        }
    }
}
</script>


<style lang="less" scoped>
.tags-view {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    min-height: 30px;
    background: #FFFFFF;
    border: 1px solid #ECECEC !important;
    border-radius: 0 !important;
    padding: 4px 11px;
    margin: 4px 0;
    /deep/ [ant-click-animating-without-extra-node]::after {
            display: none !important;
        }

}

.button-new-tag {
    margin-left: 10px;
    height: 22px;
    line-height: 22px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    height: 22px;
    line-height: 22px;
    width: 90px;
    //margin-left: 10px;
    vertical-align: bottom;
}

.tags-view::v-deep {
        .ant-tag {
            margin-top: 2px;
            margin-bottom: 2px;
        }

        .ant-input {
            height: 22px;
            line-height: 22px;

            border: none;
            padding: 0px 5px 0 0;
            box-shadow: none !important;
            &:hover, &:focus {
                box-shadow: none !important;
            }
        }
}
</style>